import { render, staticRenderFns } from "./ApplicationLayout.vue?vue&type=template&id=b8b5485c&scoped=true&"
import script from "./ApplicationLayout.vue?vue&type=script&lang=js&"
export * from "./ApplicationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b5485c",
  null
  
)

export default component.exports